import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function MarketCard({ market, prominent = false, testId }) {
  const { slug, name, flag, hero, intro, is_flagship } = market;
  return (
    <Link to={`/markets/${slug}`}
          className={`card-editorial group relative block overflow-hidden ${prominent ? "sm:col-span-2 sm:row-span-2" : ""}`}
          data-testid={testId || `market-card-${slug}`}>
      <div className={`relative ${prominent ? "aspect-[16/10]" : "aspect-[4/3]"} overflow-hidden`}>
        <img src={hero} alt={name} loading="lazy"
             className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" />
        <div className="absolute inset-0 hero-vignette" />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-5">
          {is_flagship && <span className="badge-gold bg-altura-gold text-altura-espresso border-transparent">Flagship</span>}
          <span className="ml-auto text-2xl" aria-hidden>{flag}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 text-altura-ivory">
          <div className="eyebrow text-altura-gold">{is_flagship ? "Ghana · Flagship Market" : `${name}`}</div>
          <div className={`mt-2 font-editorial ${prominent ? "text-3xl sm:text-4xl" : "text-2xl"} leading-none`}>{name}</div>
          {prominent && <p className="mt-3 max-w-md text-sm text-altura-ivory/80 leading-relaxed">{intro}</p>}
          <div className="mt-4 inline-flex items-center gap-2 text-sm text-altura-ivory group-hover:text-altura-gold transition-colors">
            Explore <ArrowUpRight className="h-4 w-4" />
          </div>
        </div>
      </div>
    </Link>
  );
}
